module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_5010.47be2a1b.png";